document.addEventListener('DOMContentLoaded', function () {
  var wrappers = document.querySelectorAll('.slideshow-cursor-wrapper');

  wrappers.forEach(function (wrapper) {
    var slides = wrapper.querySelectorAll('.slideshow__slide');
    var dots = wrapper.querySelectorAll('.slider-counter__link');
    var arrow = wrapper.querySelector('.cursor-arrow');
    var current = 0;

    function showSlide(index) {
      var total = slides.length;
      current = ((index % total) + total) % total;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active-slide', i === current);
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active-dot', i === current);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        showSlide(i);
      });
    });

    // Cursor-Pfeil folgt der Maus (nur Desktop relevant)
    wrapper.addEventListener('mousemove', function (e) {
      var rect = wrapper.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var isLeft = x < rect.width / 2;

      if (arrow) {
        arrow.style.left = x + 'px';
        arrow.style.top = (e.clientY - rect.top) + 'px';
        arrow.classList.toggle('is-left', isLeft);
      }
    });

    // Klick löst Fade zum vorherigen/nächsten Bild aus (Desktop)
    wrapper.addEventListener('click', function (e) {
      var rect = wrapper.getBoundingClientRect();
      var isLeft = (e.clientX - rect.left) < rect.width / 2;
      showSlide(isLeft ? current - 1 : current + 1);
    });

    // --- Swipe-Erkennung für Touch-Geräte ---
    var touchStartX = 0;
    var touchStartY = 0;
    var SWIPE_THRESHOLD = 40; // Mindest-Wischstrecke in Pixel, damit es als Swipe zählt

    wrapper.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });

    wrapper.addEventListener('touchend', function (e) {
      var touchEndX = e.changedTouches[0].clientX;
      var touchEndY = e.changedTouches[0].clientY;
      var deltaX = touchEndX - touchStartX;
      var deltaY = touchEndY - touchStartY;

      // Nur reagieren, wenn die Bewegung überwiegend horizontal war
      // (verhindert, dass normales vertikales Scrollen der Seite als Swipe erkannt wird)
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > SWIPE_THRESHOLD) {
        if (deltaX > 0) {
          showSlide(current - 1); // nach rechts gewischt → vorheriges Bild
        } else {
          showSlide(current + 1); // nach links gewischt → nächstes Bild
        }
      }
    }, { passive: true });

    showSlide(0);
  });
});